import * as sign from './sign';
import * as users from './users';

async function changeStates( store, states ) {

  store.setState( states );

}

export {

  changeStates,
  sign,
  users,

}